import './whatsapp.less';

const whatsappWidget = (() => {
	const handleMenuOpening = () => {
		let toggler = document.querySelector('#js-whatsapp-toggler');
		let closer = document.querySelector('#js-whatsapp-closer');
		let widget = document.querySelector('#js-whatsapp-widget');
		if (widget && toggler && closer) {
			toggler.addEventListener('click', (e) => {
				e.preventDefault();
				widget.classList.toggle('opened')
			});
			closer.addEventListener('click', (e) => {
				e.preventDefault();
				widget.classList.toggle('opened')
			});
		}
	};
	
	handleMenuOpening();
})();

export default whatsappWidget;